import axios from 'axios';
import getApiBaseUrl from '../GetServer';

// Interfaz para el payload que se enviará al backend, coincidiendo con tu clase EditClient
export interface EditClientPayload {
    IdUser: number;
    Nombre: string;
    Email: string;
    Telefono: string;
    Status: number;
}

// Interfaz para la respuesta esperada del backend
interface BackendResponse {
    status: number;
    message: string;
}

export const editClient = async (payload: EditClientPayload): Promise<BackendResponse> => {
    try {
        const baseUrl = getApiBaseUrl();
        const endpoint = `${baseUrl}dash/edit-client`;
        const token = localStorage.getItem('token');

        if (!token) {
            throw new Error('Token de autorización no disponible');
        }

        const response = await axios.post<BackendResponse>(endpoint, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        return response.data;
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || 'Error al editar el cliente';
        console.error('Error en editClient:', errorMessage, error);
        throw new Error(errorMessage);
    }
};
